import { createTheme } from '@material-ui/core/styles';

// backgrounds
const bgColorLight = 'hsla(0, 0%, 96%, 1)';
const bgColorMd = 'hsla(0, 0%, 93%, 1)';
const bgColorDark = 'hsla(0, 0%, 85%, 1)';
// borders
const borderColor = bgColorDark;
// text
const textColorPrimary = 'hsla(0, 0%, 27%, 1)';
const textColorSecondary = 'hsla(0, 0%, 42%, 1)';
// brand
const brandColorPrimary = 'hsla(231, 48%, 48%, 1)';
// box shadows
const cardBoxShadow = '0px 2px 4px rgba(0, 0, 0, 0.18)';
const avatarBoxShadow = 'inset 0px 0px 5px rgba(0, 0, 0, 0.18)';

export default createTheme({
  palette: {
    background: {
      card: bgColorLight,
      paper: bgColorLight,
    },
    primary: {
      main: brandColorPrimary,
    },
    text: {
      primary: textColorPrimary,
      secondary: textColorSecondary,
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  bgColorLight: bgColorLight,
  bgColorMd: bgColorMd,
  bgColorDark: bgColorDark,
  borderColor: borderColor,
  cardBoxShadow: cardBoxShadow,
  avatarBoxShadow: avatarBoxShadow,
});
  